export function setLoading(isLoading) {
  return {
    type: "SET_LOADING",
    isLoading,
  };
}
